import { Fragment, useEffect, type ReactNode } from "react";

import { useActiveLocale } from "./language-lens";
import { useNumberFormattingLocale } from "./number-format-lens";

export function LocaleBoundary(props: { children: ReactNode }) {
  const locale = useActiveLocale();
  const numberFormattingLocale = useNumberFormattingLocale();

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  return (
    <Fragment key={`${locale}:${numberFormattingLocale}`}>
      {props.children}
    </Fragment>
  );
}
